exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@keyframes rotation-data-v-382ac758{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}.link[data-v-382ac758]{display:inline-flex;align-items:center;color:#598ebd;line-height:1.2;transition:color 100ms ease-out}@media(hover: hover){.link[data-v-382ac758]:hover{color:#138ffe}}.link__text[data-v-382ac758]{flex:0 0 auto;line-height:1}.link__icon[data-v-382ac758]{display:block;flex:0 0 auto;margin-left:.4615384615em;font-size:.7692307692em;transform:translateY(0.0230769231em)}.link--is-color-white[data-v-382ac758]{color:#fff}", ""]);

// exports
